import { render, staticRenderFns } from "./UserPicklistItem.vue?vue&type=template&id=dde359e2&scoped=true&"
import script from "./UserPicklistItem.vue?vue&type=script&lang=js&"
export * from "./UserPicklistItem.vue?vue&type=script&lang=js&"
import style0 from "./UserPicklistItem.vue?vue&type=style&index=0&id=dde359e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde359e2",
  null
  
)

export default component.exports